import { render, staticRenderFns } from "./attorney-prepared-sellers-documents.vue?vue&type=template&id=1b561d0c"
import script from "./attorney-prepared-sellers-documents.vue?vue&type=script&lang=js"
export * from "./attorney-prepared-sellers-documents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports